import React, { useContext } from "react";
import { Language } from "../../App";
import { MdOutlineCalendarMonth, MdArrowForward } from "react-icons/md";
import "./CreateAgendaCard.css";

export default function CreateAgendaCard({ onClick, onCreateClick, onCreateEvent }) {
  const { lang } = useContext(Language) || {};
  const handleClick = onClick || onCreateClick || onCreateEvent;

  return (
    <div className="agenda-create-card cr-create-card">
      <div className="agenda-create-top-row cr-create-top-row">
        <div className="agenda-create-circle-icon cr-create-circle-icon">
          <MdOutlineCalendarMonth size={28} />
        </div>
        <div className="agenda-create-text-wrap cr-create-text-wrap">
          <h4 className="agenda-create-heading cr-create-heading">
            {lang?.create_new_agenda || "Create New Agenda"}
          </h4>
          <p className="agenda-create-desc cr-create-desc">
            {lang?.create_agenda_card_para ||
              "Schedule and host medical events, webinars, or clinical sessions."}
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={handleClick}
        className="agenda-create-action-btn cr-create-action-btn"
        id="agenda-create-card-btn"
        aria-label={lang?.create_agenda || "Create Agenda"}
      >
        <span>{lang?.create_agenda || "Create Agenda"}</span>
        <MdArrowForward size={16} />
      </button>
    </div>
  );
}
